// extracted by mini-css-extract-plugin
export default {"outlet":"realtime_outlet__3QVY7","title":"realtime_title__BSZ0c","progress":"realtime_progress__GdJQe","workspace":"realtime_workspace__1Ulj1"};